import { configureStore } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';
import { rootReducer } from './rootReducer';

// These are reducers that contain non-serializable data so we are explicitly
//  excluding them from the serializableStateInvariant middleware check
// https://redux-toolkit.js.org/api/getDefaultMiddleware#development
const NON_SERIALIZABLE_REDUCER_PATHS = ['baseModalSettings', 'contentModel', 'contentReadOnlyData', 'editSidebar', 'formStatus.errors', 'hardSavedContentModel', 'inpageData', 'inpageModals', 'layoutData', 'locallyCachedSettings', 'moduleErrors', 'modules', 'optimizationState', 'panesVisitStatus', 'portal', 'portalDomains', 'resources.goToWebinar.eligibleForms', 'selection', 'siteSettings', 'sidebarState', 'templateInfo', 'testFlags', 'uploadedFeaturedImages', 'userAttributes'];
export const initStore = preloadedState => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: getDefaultMiddleware => getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: NON_SERIALIZABLE_REDUCER_PATHS
      }
    })
  });
};
export const useAppDispatch = useDispatch;
export const useAppSelector = useSelector;